export class User {
    constructor(
        public id: number,
        public nom: string,
        public email: string,
        public portrait: string,
        public prenom: string,
        public tel: string,
        public token: string
    ){

    }
    
}


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/models/user.ts